import React from 'react'
import PropTypes from 'prop-types'

import styled from 'styled-components'

import CsgTypography from 'components/atoms/Typography'

import theme from 'app/theme'

const Value = styled(CsgTypography)`
  && {
    font-size: 2.5rem;
    font-weight: 800;
    color: ${props => theme.palette[props.color].main};
  }
`

const Description = styled(CsgTypography)`
  && {
    margin-top: 3px;
    color: ${props => theme.palette[props.color].main};
  }
`

const HomeValue = ({ color, description, children }) => (
  <>
    <Value variant="h3" color={color}>
      {children}
    </Value>

    {description && (
      <Description variant="subtitle1" color={color}>
        {description}
      </Description>
    )}
  </>
)

HomeValue.propTypes = {
  mainColor: PropTypes.string,
  description: PropTypes.string
}

export default HomeValue
